import dialog from "webmodals/dialog";

export default (body, title, size) =>
  dialog({
    closeButton: "close",
    body,
    title,
    size,
    buttons: {
      OK: {},
    },
  });
